import {
  SR_API_ACTION_AGENT_GET_TOURS,
} from 'api/actionTypes';
import {
  TOUR_STATUS_COMPLETED,
} from 'common/tourConstants';

import setViewingTour from './setViewingTour';

export default async function getAgentTours(
  { state, apiClient },
  { agentUserId, resetViewingTour, includeTours }
) {
  await apiClient.postWithState({
    action: SR_API_ACTION_AGENT_GET_TOURS,
    state: state,
    payload: {
      agentUserId,
      includeTours,
    },
    onSuccess(tours) {
      state.set(['agent', 'tours'], tours);
      state.set(['agent', 'agentUserId'], agentUserId);

      const viewingTour = state.get(['agentMapView', 'viewingTour']);
      const tourIds = tours.map(({ id }) => id);

      if (resetViewingTour || !viewingTour) {
        const tour = tours.find((tour) => tour.status !== TOUR_STATUS_COMPLETED);
        if (tour) {
          setViewingTour({ state }, tour.id);
        }
      }
      else if (viewingTour && tourIds.includes(viewingTour.id)) {
        const tourUpdated = tours.find((tour) => tour.id === viewingTour.id);
        state.set(['agentMapView', 'viewingTour'], tourUpdated);
      }
    },
  });
}
